import request from '@/utils/request'
const BASE_URL = '/ali/message'

export default {
  getMessage() {
    return request({
      url: BASE_URL,
      method: 'get',
    })
  },
  read(ids) {
    return request({
      url: BASE_URL + "/read",
      method: "post",
      data: ids
    })
  }
}